/**
 * The choices offered by SELECT_MODEL_PORTFOLIO_EDIT_TYPE, in branch order.
 *
 * A choice's position here becomes its branch handle id, which is what an admin
 * drags a branch from in the workflow editor and what the step reports back
 * when the user picks it. The order must stay fixed, and must never be derived
 * from which choices are enabled: renumbering would silently repoint branches
 * that have already been drawn.
 *
 * A choice with `requiresMultipleAccounts` is offered but disabled for a
 * household that has only one account.
 *
 * A choice with `requiresCustomizedAllocationsWorkflow` is hidden unless the
 * flag of that name is on. Its branch leads to steps the same flag adds to the
 * workflow editor, so without it there is nowhere for the branch to go.
 */
export const modelPortfolioEditChoices = [
  {
    name: 'editModelPortfolio',
    requiresCustomizedAllocationsWorkflow: false,
    requiresMultipleAccounts: false,
    enableKey: 'enableEditModelPortfolio',
    labelKey: 'editModelPortfolioLabel',
    descriptionKey: 'editModelPortfolioDescription',
  },
  {
    name: 'changeModelPortfolio',
    requiresCustomizedAllocationsWorkflow: false,
    requiresMultipleAccounts: false,
    enableKey: 'enableChangeModelPortfolio',
    labelKey: 'changeModelPortfolioLabel',
    descriptionKey: 'changeModelPortfolioDescription',
  },
  {
    name: 'detachModelPortfolio',
    requiresCustomizedAllocationsWorkflow: false,
    requiresMultipleAccounts: false,
    enableKey: 'enableDetachModelPortfolio',
    labelKey: 'detachModelPortfolioLabel',
    descriptionKey: 'detachModelPortfolioDescription',
  },
  {
    name: 'changeIps',
    requiresCustomizedAllocationsWorkflow: false,
    requiresMultipleAccounts: false,
    enableKey: 'enableChangeIps',
    labelKey: 'changeIpsLabel',
    descriptionKey: 'changeIpsDescription',
  },
  {
    name: 'editAccountAllocations',
    requiresCustomizedAllocationsWorkflow: true,
    requiresMultipleAccounts: true,
    enableKey: 'enableEditAccountAllocations',
    labelKey: 'editAccountAllocationsLabel',
    descriptionKey: 'editAccountAllocationsDescription',
  },
] as const;

/**
 * Choices default to enabled, matching the sub-step option defaults, so an
 * unconfigured step still offers every choice.
 */
export const isChoiceEnabled = (
  options: Record<string, unknown> | undefined,
  enableKey: string,
) => options?.[enableKey] !== false;
